import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import AcxDialog from "components/UI/Dialog/AcxDialog";
import AcxButton from "components/UI/AcxButton";
import AcxSelectSingle from "components/UI/Select/BaseSelectComponents/AcxSelectSingle";
import { useStore } from "utils/useStore";
import { ApplicationFilterValuesStore } from "stores/ApplicationFilters/ApplicationFilterValuesStore";
import { SlimLLMClassifierResponse } from "models/LLMs";
import { Suggestion } from "../Suggestions/Suggestion";
import { useCurrentChatStore } from "components/KBo/Stores/useCurrentChat";
import { ActionProps } from "./Actions";

export const SelectModelAction: React.FC<ActionProps> = observer(({ args }) => {
    const currentChatStore = useCurrentChatStore();
    const valuesStore = useStore(ApplicationFilterValuesStore);
    const [model, setModel] = useState<SlimLLMClassifierResponse | undefined>();
    const [dialogOpen, setDialogOpen] = useState(false);

    useEffect(() => {
        if (!dialogOpen) return;
        if (valuesStore.llmClassifiers) return;
        valuesStore.loadLLMClassifiers();
    }, [dialogOpen, valuesStore]);

    return (
        <React.Fragment>
            <AcxDialog
                isOpen={dialogOpen}
                onClose={() => {
                    setDialogOpen(false);
                }}
                title="Models"
                maxWidth="lg"
                dialogContentChildren={
                    <AcxSelectSingle
                        id="kbo-select-model"
                        options={valuesStore.llmClassifiers ?? []}
                        isLoading={valuesStore.getTaskLoading(
                            ApplicationFilterValuesStore.Tasks
                                .LOAD_LLM_CLASSIFIERS,
                        )}
                        labelField="name"
                        valueField="id"
                        containerHeight="auto"
                        minWidth="24rem"
                        onChange={(selectedModel) => setModel(selectedModel)}
                    />
                }
            >
                <AcxButton
                    fullWidth={false}
                    onClick={() => {
                        if (!model) return;
                        currentChatStore?.streamingSubmitInput({
                            userMessage: model.name,
                            manualInput: `Use the following model in your filters: "${model.name}"`,
                        });
                    }}
                    disabled={!model}
                >
                    Use selected model
                </AcxButton>
            </AcxDialog>
            <Grid item>
                <Suggestion onClick={() => setDialogOpen((open) => !open)}>
                    {args?.buttonText || "Select Model"}
                </Suggestion>
            </Grid>
        </React.Fragment>
    );
});
